import axios from 'axios'
import router from './router'
import store from './store'

const api = axios.create({
  baseURL: `https://backend.origamiturismosistema.com.br/api/admin/`,
  // baseURL: `http://localhost:8000/api/admin/`,
  headers: {
    Authorization: `Bearer ${window.localStorage.getItem('origami_admin_token')}`,
    Accept: 'application/json',
    'Content-Type': 'application/json'
  },
  validateStatus: (status) => {
    if (status === 401 || status === 403) {
      store.commit('setUser', null)
      store.commit('setToken', null)
      window.localStorage.setItem('origami_admin_user', null)
      window.localStorage.setItem('origami_admin_token', null)
      router.push({'name': 'Login'})
    }
    return status >= 200 && status < 300
  }
})

if (window.localStorage && window.localStorage.getItem('origami_admin_user') !== 'undefined') {
  if (store.state.user !== window.localStorage.getItem('origami_admin_user')) {
    store.commit('setUser', JSON.parse(window.localStorage.getItem('origami_admin_user')))
    store.commit('setToken', window.localStorage.getItem('origami_admin_token'))
  }
}

api.interceptors.request.use((config) => {
  return config
}, (error) => {
  return Promise.reject(error)
})

export default api



// WEBPACK FOOTER //
// ./src/api.js